import { TermsAndConditions } from '@project/components';
import React from 'react';

export const TermsAndConditionsPage: React.FC = () => {
  return <TermsAndConditions />;
};
